import { createSlice } from '@reduxjs/toolkit'
import { embedsToQuery, getTasksWithQuery } from '../lib/api'
import { DEFAULT_EMBEDS } from '../providers/TaskAPIProvider'

const initialState = {
  loaded: [],
  tasks: {},
  error: null
}

const userTaskCacheSlice = createSlice({
  name: 'userTaskCache',
  initialState,
  reducers: {
    startLoad: (state, { payload }) => {
      state.loaded.push(payload)
    },

    finishLoad: (state, { payload }) => {
      const { id, tasks } = payload
      state.tasks[id] = tasks
    },

    clearError: state => {
      state.error = null
    },

    setError: (state, { payload }) => {
      state.error = payload
    }
  }
})

const { startLoad, finishLoad, clearError, setError } =
  userTaskCacheSlice.actions

export const loadUsersTasks = (id, isContact, cb, force = false) => {
  return async (dispatch, getState) => {
    const { loaded } = getState().userTaskCache

    if (loaded.includes(id) && !force) {
      return
    }

    try {
      dispatch(clearError())
      dispatch(startLoad(id))

      let page = 0
      const perPage = 25
      const getQuery = () =>
        `${embedsToQuery(DEFAULT_EMBEDS)}&${
          isContact ? 'concerning_user_id' : `assigned_to[]`
        }=${id}&include_closed=true&per_page=${perPage}&page=${page}`

      // Initial query to figure out total
      const {
        data,
        pagination: { total }
      } = await getTasksWithQuery(getQuery())
      const tasks = [...data]

      // Get all remaining pages of tasks
      while ((page + 1) * perPage < total) {
        page += 1
        const { data } = await getTasksWithQuery(getQuery())
        tasks.push(...data)
      }

      cb && cb({ data: tasks })
      dispatch(finishLoad({ id, tasks: tasks.map(task => task.id) }))
    } catch (err) {
      dispatch(setError(err))
    }
  }
}

export const selectUserTaskCache = state => state.userTaskCache

export default userTaskCacheSlice.reducer
